import styles from "../privacy-policy/PrivacyPolicy.styles";
import { useI18n } from "../../i18n";
import Seo from "../../components/Seo";

export default function TermsConditions() {
  const { t } = useI18n();
  return (
    <div className={`${styles.container}`}>
      <Seo title={t("seo_terms_title")} description={t("seo_terms_desc")} />
      <h1>{t("terms_title")}</h1>
      <h4>{t("terms_effective")}</h4>
      <h3>{t("terms_acceptance")}</h3>
      <p>
        By accessing and using the Zilouet website, you agree to comply with and
        be bound by these Terms & Conditions. If you do not agree with any part
        of these terms, please do not use our site.
      </p>
      <h3>{t("terms_general")}</h3>
      <p>
        Zilouet provides information regarding our application. The website does
        not facilitate online purchases and is intended solely for informational
        purposes.
      </p>
      <h3>{t("terms_user_info")}</h3>
      <p>
        When you contact us via the website, we may collect your name and email
        address. This information is used solely for responding to your
        inquiries and is not shared with third parties.
      </p>
      <h3>{t("terms_age")}</h3>
      <p>
        There are no age restrictions for using this website. Anyone may access
        the information provided here.
      </p>
      <h3>{t("terms_no_login")}</h3>
      <p>
        Users are not required to create an account or log in to access the
        website. There are no subscription services or newsletters associated
        with Zilouet.
      </p>
      <h3>{t("terms_ip")}</h3>
      <p>
        All content on the Zilouet website, including text, graphics, logos, and
        images, is the property of Zilouet and is protected by copyright and
        other intellectual property laws. You may not reproduce, distribute, or
        use any content from this site without prior written consent from
        Zilouet.
      </p>
      <h3>{t("terms_limitation")}</h3>
      <p>
        Under no circumstances shall Zilouet be liable for any direct, indirect,
        incidental, or consequential damages resulting from the use or inability
        to use the website or its content.
      </p>
      <h3>{t("terms_changes")}</h3>
      <p>
        Zilouet reserves the right to modify these Terms & Conditions at any
        time. We will notify users of any changes by updating the date at the
        top of this page. Continued use of the website after such changes
        constitutes your acceptance of the new Terms & Conditions.
      </p>
      <h3>{t("terms_contact")}</h3>
      <p>
        For any questions regarding these Terms & Conditions, please contact us
        directly via the contact form on our website.
      </p>
    </div>
  );
}
